import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CourseService } from '../../../../services/course.service';

@Component({
    selector: 'app-file-manager',
    templateUrl: './file-manager.component.html',
    styleUrls: ['./file-manager.component.scss'],
    standalone: false
})
export class FileManagerComponent implements OnInit {
  constructor(
    private courseService: CourseService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}
  @Output() selectFile = new EventEmitter<any>();
  @Input() allowSelection;
  @Input() filter;
  @Input() item: any = {};
  @Input() source;
  active = 'Course';
  course;
  ngOnInit(): void {
    this.course = this.courseService.id;
    if (!this.course) {
      this.active = 'Global';
    }
    this.activatedRoute.queryParams.subscribe(d => {
      this.active = d.scope || (this.course ? 'Course' : 'Global');
    });
  }

  passSelectedFile(e) {
    this.selectFile.emit(e);
  }

  changeTab(e) {
    console.log('Change Tab', e);
    if (this.active !== e.tabTitle) {
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { term: null, folder: null, scope: e.tabTitle },
        queryParamsHandling: 'merge',
      });
    }
  }
}
